import cn from "classnames";
import Link from "next/link";
import { useCallback } from "react";
import { toast } from "react-toastify";

import { EDITABLE_LINK_VARIANTS } from "@config/cms";
import { useStore } from "@hooks/useZustandProvider";
import i from "@styles/icons.module.scss";
import Button from "@ui-kit/Button/Button";

import s from "./EditableLink.module.scss";

const cursorNotice = "Double click to edit link/button.";

const EditableLink = ({
  link,
  data = {},
  onChange,
  className,
  isButtonTypeLink = false,
  variant = EDITABLE_LINK_VARIANTS.forward,
}) => {
  const isBack = variant === EDITABLE_LINK_VARIANTS.back;
  const Icon = isBack ? (
    <icon className={i.arrowLeft} />
  ) : (
    <icon className={i.arrowRight_v2} />
  );
  const { cms, updateModals, modals } = useStore();
  const { isWidget } = cms.page;
  const { isWidgetEditing } = cms.widget;
  const { isOpenSetttingShowMoreModal } = modals;
  const { isEditMode } = cms.uiOptions;

  const toggleSetttingShowMoreModal = () => {
    updateModals({
      isOpenSetttingShowMoreModal: !isOpenSetttingShowMoreModal,
    });
  };

  const handleClickToEdit = useCallback((e) => {
    switch (e.detail) {
      case 2:
        toggleSetttingShowMoreModal();
    }
  }, []);

  if (isEditMode) {
    return isButtonTypeLink ? (
      <Button
        className={cn(s.link, s.button, className)}
        text={data.text}
        {...(isEditMode && !(!isWidgetEditing && isWidget)
          ? {
              "data-cursor-notice": cursorNotice,
              onClick: handleClickToEdit,
            }
          : {
              onClick: () => {
                toast.warning(
                  "To edit a widget you need to enable widget editing mode",
                );
              },
            })}
      />
    ) : (
      <div
        className={cn(s.link, isBack && s.back, className)}
        {...(isEditMode && !(!isWidgetEditing && isWidget)
          ? {
              "data-cursor-notice": cursorNotice,
              onClick: handleClickToEdit,
            }
          : {
              onClick: () => {
                toast.warning(
                  "To edit a widget you need to enable widget editing mode",
                );
              },
            })}
      >
        {isBack && Icon}
        {data.text}
        {!isBack && Icon}
      </div>
    );
  }

  return isButtonTypeLink ? (
    <Button
      className={cn(s.link, s.button, className)}
      text={data.text}
      to={data.link || link}
    />
  ) : data.link || link ? (
    <Link
      className={cn(s.link, isBack && s.back, className)}
      href={data.link || link}
    >
      {isBack && Icon}
      {data.text}
      {!isBack && Icon}
    </Link>
  ) : null;
};

export default EditableLink;
